import http, { BACK_URL } from './http'

export function getProducts(params = {}, config = {}) {
  return http.get('product', { params, ...config }).then((res) => normalizeProductsResponse(res.data))
}

export function createProduct(data) {
  return http.post('product', productFormData(data)).then((res) => normalizeProduct(res.data))
}

export function updateProduct(id, data) {
  const formData = productFormData(data)
  formData.append('_method', 'PUT')
  return http.post(`product/${id}`, formData).then((res) => normalizeProduct(res.data))
}

export function deleteProduct(id) {
  return http.delete(`product/${id}`).then((res) => res.data)
}

export function updateProductCount(data) {
  return http.post('product/count', data).then((res) => res.data)
}

export function writeOffProductWaste(data) {
  return http.post('product/waste', data).then((res) => res.data)
}

export function getProductSettlements(id) {
  return http.get(`product/${id}/settlements`).then((res) => {
    const data = res.data || {}
    return {
      ...data,
      product: data.product ? normalizeProduct(data.product) : data.product,
    }
  })
}

export function createProductSettlement(id, data) {
  return http.post(`product/${id}/settlements`, data).then((res) => normalizeSettlementResponse(res.data))
}

export function updateProductSettlement(id, settlementId, data) {
  return http.put(`product/${id}/settlements/${settlementId}`, data).then((res) => normalizeSettlementResponse(res.data))
}

export function deleteProductSettlement(id, settlementId) {
  return http.delete(`product/${id}/settlements/${settlementId}`).then((res) => normalizeSettlementResponse(res.data))
}

function normalizeSettlementResponse(payload = {}) {
  return {
    ...payload,
    product: payload.product ? normalizeProduct(payload.product) : payload.product,
  }
}

function productFormData(data) {
  const formData = new FormData()
  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined) return
    if (key === 'modifier_ids' || key === 'expenses' || key === 'wastes' || key === 'byproducts') {
      formData.append(key, JSON.stringify(Array.isArray(value) ? value : []))
      return
    }
    formData.append(key, value === null ? '' : value === true ? '1' : value === false ? '0' : value)
  })
  return formData
}

function normalizeProductsResponse(response) {
  if (Array.isArray(response && response.data)) {
    return {
      ...response,
      data: response.data.map(normalizeProduct),
    }
  }
  return response
}

function normalizeProduct(product) {
  if (!product || typeof product !== 'object') return product

  return {
    ...product,
    image_url: product.image_path ? storageUrl(product.image_path) : product.image_url,
    image_thumb_url: product.image_thumb_path ? storageUrl(product.image_thumb_path) : product.image_thumb_url,
  }
}

function storageUrl(path) {
  return `${BACK_URL.replace(/\/+$/, '')}/storage/${String(path).replace(/^\/+/, '')}`
}
